import React from 'react';
import PropTypes from 'prop-types';
import $ from 'jquery';
import _ from 'lodash';
import Middleware from './../middleware';
import ProjectScope from './projectScope/projectScope';
import ActionTypes from './../actionTypes';
import StonesStore from './../stores/stonesStore';
import TimerView from './common/timer/timerView';
import * as Misc from './../misc';
import Config from './../config';
import SquareFootCalculatorView from './squareFootCalculatorView';
import Analytics from './../analytics';
import MessageBox from './common/messageBox/messageBox';
import KitchenVisualizerIFrame from './projectSummary/kitchenVisualizerIFrame';
import MobileRotateButton from './mobileRotateButton';
import LoaderView from "./common/loaderView";
import ConfirmDialog from "./common/confirmDialog";
import HomeButton from "./homeButton";

export default class MainView extends React.Component {
  static contextTypes = {
    router: PropTypes.object.isRequired
  };
  state = {
    currentQuote: ProjectScope.quote(),
    quotesCount: ProjectScope.quotesCount(),
    visitedPages: [],
    isDialogVisible: false,
    handleDialogNoClick: null,
    handleDialogYesClick: null,
    isMessageBoxVisible: false,
    messageBoxText: '',
    messageBoxIsError: false,
    switchToKV: false,
    iframeOpened: false,
    'debug-loader': false,
    delta: 0, //  how much we need to swipe the page to change step
    reloadIframe: false
  };

  constructor(props) {
    super(props);
    this.x = 0;
    this.y = 0;
    this.statusSwipe = false;
    this.detectedSwipe = false;
  }

  componentDidMount() {
    $(document).on(ActionTypes.QUOTE_DATA_CHANGED, this.handleQuoteChanged);
    $(document).on(ActionTypes.SERVER_DATA_READY, this.handleServerDataLoaded);
    $(document).on(ActionTypes.QUOTE_DELETED, this.handleQuoteDeleted);

    StonesStore.getStoneAndFeatureIDsFromUrl();

    Middleware.loadServerData(ProjectScope.jobId);

    this.context.router.listen(this.handleRouterChange);
    this.state.visitedPages['/scope'] = true;

    document.backFromIframe = () => {
      this.setState({
        switchToKV: !this.state.switchToKV,
      });
      setTimeout(() => {
        $('#app').removeClass('js--switched');
      }, 2000);
    };
    document.reloadIframeStyles = () => {
      this.setState({
        iframeOpened: true
      })
    };
    document.reloadIframe = () => {
      // ProjectScope.reset(); // show new features in iframe, but do not change in the list
    };
    document.addEventListener('debug-loader', () => {
      this.setState({'debug-loader': true});
    });
    window.debugLoader = () => document.dispatchEvent(new Event('debug-loader'));
    //console.log('execute window.debugLoader() to debug loading dialog');

    $.expr.filters.offscreen = function (el) {
      const rect = el.getBoundingClientRect();
      return (
        (rect.x + rect.width) < 0
        || (rect.y + rect.height) < 0
        || (rect.x > window.innerWidth || rect.y > window.innerHeight)
      );
    };

    window.addEventListener('orientationchange', function () {  //  http://jira.mozidev.com/browse/QC-950
      document.body.style.display = 'none';
      setTimeout(function () {
        document.body.style.display = 'block';
      }, 10);
    });

    $(window).on('resize', this.handleOrientationChange);
    this.handleOrientationChange();

    if(window.mixpanel)
      window.mixpanel.track_links(".header-info-phone-number a", " clicked-on ", {"Phone": "Client Phone" });
  }

  handleQuoteDeleted = () => {  // re-render KV iframe
    this.setState({
      reloadIframe: true
    }, () => {
      this.setState({
        reloadIframe: false
      });
    });
  };

  handleOrientationChange = () => {
    this.setState({
      delta: $(window).width() / 3
    })
  };

  componentDidUpdate() {
    const currentPage = this.getCurrentPage();
    if (currentPage.path !== "/summary" && currentPage.path !== "/stones") {
      this.scrollDockCheck();
    }
    //_.last(this.props.routes).path !== "/summary" && _.last(this.props.routes).path !== "/stones" && this.scrollDockCheck();
  }

  componentWillUnmount() {
    $(document).off(ActionTypes.QUOTE_DATA_CHANGED, this.handleQuoteChanged);
    $(document).off(ActionTypes.SERVER_DATA_READY, this.handleServerDataLoaded);
  }

  handleRouterChange = (e) => {
    this.state.visitedPages[e.pathname] = true;
    if (!e.pathname.includes('summary')) {
      this.handleQuoteDeleted();  // reload iframe
    }
  };

  handleServerDataLoaded = (e, data) => {
    ProjectScope.loadJobData(data.jobData);
    // after initial data is loaded we need to calculate the initial stone pricing
    ProjectScope.recalculateAll(false, true);
    // first time app loads need to remember the first cheapest stone that will be unlocked for
    // non-logged users
    ProjectScope.saveUnlockedStones();
    // after this, subscription is no longer needed
    $(document).off(ActionTypes.SERVER_DATA_READY, this.handleServerDataLoaded);
    if (ProjectScope.isBackend) {
      this.state.visitedPages['/scope'] = true;
      this.state.visitedPages['/stones'] = true;
      this.state.visitedPages['/summary'] = true;
      this.context.router.push('/summary');
    } else {
      $(document).trigger(ActionTypes.QUOTE_DATA_CHANGED, {});
    }
  };

  getCurrentPage = () => {
    const path = _.last(this.props.routes).path || "/scope";
    let pageName = "Invalid Page";
    let pageStub = "invalid-page";
    switch (path) {
      case "/scope":
        pageName = "Project Scope";
        pageStub = "project-scope";
        break;
      case "/stones":
        pageName = "Stone Selection";
        pageStub = "stone-selection";
        break;
      case "/summary":
        pageName = "Summary View";
        pageStub = "summary-view";
        break;
    }
    return {
      path,
      pageName,
      pageStub
    };
  }

  handleQuoteChanged = (e, data) => {
    this.setState({
      currentQuote: ProjectScope.quote(),
      quotesCount: ProjectScope.quotesCount()
    });
  };

  removeDockedStyles() {
    $('.header-bar-docked').removeClass('header-bar-docked');
    $('.stone-filters-wrapper-docked').removeClass('stone-filters-wrapper-docked');
  }

  handleNextClick = (e) => {
    const currentPage = this.getCurrentPage();
    let userInfo = ProjectScope.userInfo();
    Analytics.sendClickEvent(currentPage.pageStub + '-next-page-button');
    Analytics.sendClickEvent('next-page-button');
    Misc.ignoreDefault(e);
    let newPath = '';
    switch (currentPage.path) {
      case "/scope":
        if (!StonesStore.stonesLoaded()) {
          return; // need to wait till stones are loaded
        }
        this.removeDockedStyles();
        newPath = '/stones';
        Misc.hideQQGirl();
        break;
      case "/stones":
        let haveStones = this.quotesHaveStones();
        if (haveStones && (!userInfo || userInfo.isPhoneNumberValidated || ProjectScope.isBackend)) {
          this.removeDockedStyles();
          newPath = '/summary';
        } else if(!haveStones) {
          this.showMessage("Cannot go to the summary page without selecting a stone.", true);
          return;
        } else if(userInfo && !userInfo.isPhoneNumberValidated && !ProjectScope.isBackend) {
          $(document).trigger('show-phone-validation');
          return;
        }
        break;
      case "/summary":
        this.removeDockedStyles();
        if (this.quotesHaveStones()) {
          // use chose to submit the quote, show the summary screen
          // and lock user on summary page
          ProjectScope.quoteSubmitted = true;

          // save the quote
          // need to decide what shall we do when quote saving ended with an error
          // theoretically shall not happen, only in case something bad goes on server
          Middleware.saveQuote(true, true);
        } else {
          this.showMessage("Not all quotes have a stone selected.  Please select a stone for all quotes in the job.", true);
          return;
        }
        break;
    }

    if (newPath === '') {
      return;
    }

    Analytics.sendPageEvent(newPath);

    this.context.router.push(newPath);
    const mainWrapper = $('.main-wrapper');
    mainWrapper.scrollTop(mainWrapper.scrollTop() - 1);
  };

  quotesHaveStones = () => {
    let quotesHaveStones = true;
    _.each(ProjectScope.quotes(), (q) => {
      console.log(q.stone);
      quotesHaveStones = quotesHaveStones && (q.stone && q.stone.Id);
    });
    return quotesHaveStones;
  };

  handlePrevClick = (e) => {
    Analytics.sendPageEvent('previous-page-button');
    Misc.ignoreDefault(e);
    if (ProjectScope.quoteSubmitted) {
      return;
    }

    const currentPage = this.getCurrentPage();
    //const path = _.last(this.props.routes).path || "/scope";
    let newPath = '';
    switch (currentPage.path) {
      case "/summary":
        newPath = '/stones';
        break;
      case "/stones":
        newPath = '/scope';
        break;
    }

    if (newPath === '') {
      return;
    }

    Analytics.sendPageEvent(newPath);

    this.context.router.push({
      pathname: newPath
    });
    const mainWrapper = $('.main-wrapper');
    mainWrapper.scrollTop(mainWrapper.scrollTop() - 1);
  };

  handleGoToClick = (page, e) => {
    Analytics.sendClickEvent('click-direct-page-' + page);
    Misc.ignoreDefault(e);
    if (!ProjectScope.isBackend && ProjectScope.quoteSubmitted) {
      return;
    }

    const currentPage = this.getCurrentPage();
    //const path = _.last(this.props.routes).path || "/scope";
    if (page === currentPage.path) {
      return;
    }

    switch (page) {
      case '/summary':
        if (this.quotesHaveStones()) {
          if (!this.state.visitedPages['/stones'] || !ProjectScope.userInfo()) {
            return;
          }
        } else {
          this.showMessage("Cannot go to the summary page without selecting a stone.", true);
          return;
        }
        break;
    }

    Analytics.sendPageEvent(page);

    this.state.visitedPages[page] = true;
    this.context.router.push(page);
  };

  lastPosition = 0;

  scrollDockCheck = () => {
    this.scrollDockCheck.header = this.scrollDockCheck.header || $('div.header-bar');
    this.scrollDockCheck.window = $('.main-wrapper');
    this.scrollDockCheck.home = $('.home-button');
    this.scrollDockCheck.window.scroll(() => {
      const newPos = this.scrollDockCheck.window.scrollTop();
      if (newPos > 1) {
        if (!this.scrollDockCheck.header.hasClass('header-bar-docked')) {
          this.scrollDockCheck.header.add(this.scrollDockCheck.home).addClass('header-bar-docked');
        }
      } else {
        if (this.scrollDockCheck.header.hasClass('header-bar-docked')) {
          this.scrollDockCheck.header.add(this.scrollDockCheck.home).removeClass('header-bar-docked');
        }
      }
      if (newPos < this.lastPosition) { //scrolling down
        this.scrollDockCheck.header.add(this.scrollDockCheck.home).addClass("open");
      } else if (newPos > this.lastPosition) {
        this.scrollDockCheck.header.add(this.scrollDockCheck.home).removeClass("open");
      }
      this.lastPosition = this.scrollDockCheck.window.scrollTop();
    });
  };

  isDocked = () => {
    this.scrollDockCheck.window = this.scrollDockCheck.window || $('.main-wrapper');
    return (this.scrollDockCheck.window.scrollTop() > 1);
  };

  showMessage = (text, isError = false) => {
    //console.log('showMessage', text, isError);
    this.setState({
      isMessageBoxVisible: true,
      messageBoxText: text,
      messageBoxIsError: isError
    }, () => {
      //console.log(this.state);
    });
  };

  handleMessageBoxOkClick = () => {
    this.setState({
      isMessageBoxVisible: false,
      messageBoxText: '',
      messageBoxIsError: false
    });
  };

  handlePhoneNumberClick = () => {
    const currentPage = this.getCurrentPage();
    Analytics.sendClickEvent(currentPage.pageStub + "-phone-number-clicked");
  };

  toggleSwitchToKV = () => {
    const currentPage = this.getCurrentPage();
    Analytics.sendClickEvent(currentPage.pageStub + "-view-in-visualizer");
    // if(!this.state.switchToKV && ProjectScope.userInfo()) {
    //   console.log('XXXX');
    //   $('iframe[name=kviframe]').each(function() {
    //     let ifrm = this;
    //     const frmDoc = ifrm.contentDocument || ifrm.contentWindow.document || ifrm.document;
    //     const userInfo = ProjectScope.userInfo();
    //     userInfo.fromQT = true;
    //     if(frmDoc && frmDoc.updateUserInfo) {
    //       console.log('X1', userInfo);
    //       userInfo.xxx = 'yyy';
    //       //$(frmDoc).trigger(ActionTypes.UPDATE_USER_INFO, userInfo);
    //       frmDoc.updateUserInfo(ActionTypes.UPDATE_USER_INFO, userInfo);
    //     }
    //   });
    // }
    $(document).trigger(this.state.switchToKV ? "resume_timer" : "suspend_timer");
    this.setState({
      switchToKV: !this.state.switchToKV,
    }, () => {
      setTimeout(() => {
        $('#app').addClass('js--switched');
      }, 2000);
    });
  };

  // renderIframeLink = () => {
  //   let {domain, protocol} = Misc.extractDomain(window.location.href);
  //   let postFix = '/kv';
  //   if (window.location.port === '9007') {
  //     domain = 'localhost:9001';
  //     postFix = '';
  //   }
  //   let url = (protocol || 'http') + '://' + domain + `${postFix}`;
  //   if (parent.window.kioskGoToKV) {
  //     url = '../KitchenVisualizer/index.html';
  //   }
  //   return url
  // };

  moveStart = (e) => {

    const stonesPage = (_.last(this.props.routes).path === "/stones"),
      reviewPage = (_.last(this.props.routes).path === "/summary"),
      $width = $(window).width();

    if ($width < 768 && (stonesPage || reviewPage) && !this.state.switchToKV) {

      // e.preventDefault();
      this.x = parseFloat(e.clientX ? e.clientX : (e.touches[0] ? e.touches[0].clientX : e.changedTouches[0].clientX)).toFixed(2);
      this.y = parseFloat(e.clientY ? e.clientY : (e.touches[0] ? e.touches[0].clientY : e.changedTouches[0].clientY)).toFixed(2);

      if (stonesPage) {
        if (this.x < ($width - 20)) {
          this.statusSwipe = true;
        }
      } else {
        this.statusSwipe = true;
      }

      this.detectedSwipe = false;

    }
  };

  move = (e) => {

    const stonesPage = (_.last(this.props.routes).path === "/stones"),
      reviewPage = (_.last(this.props.routes).path === "/summary");

    if ($(window).width() < 768 && (stonesPage || reviewPage) && !this.state.switchToKV) {

      if (this.statusSwipe) {

        const mainApp = $('.main-wrapper');
        const fading = stonesPage ? $('.header-logo, .stone-filter').add($('.step2Cont').filter(function () {
          return !$(this).is(':offscreen')
        })) : $('.header-logo, .review-submit-screen-title, .review-submit-side-divider-left, .review-submit-right-logo, .review-submit-scroll-pane');

        fading.addClass('transition2');
        mainApp.addClass('grabbable');

        let x = parseFloat(e.clientX ? e.clientX : (e.touches[0] ? e.touches[0].clientX : e.changedTouches[0].clientX)).toFixed(2),
          y = parseFloat(e.clientY ? e.clientY : (e.touches[0] ? e.touches[0].clientY : e.changedTouches[0].clientY)).toFixed(2),
          tX = parseFloat((x - this.x).toFixed(2)),
          tY = parseFloat((y - this.y).toFixed(2));

        if (!this.detectedSwipe) {
          if (Math.abs(parseFloat(tX)) >= this.props.delta) {
            if (parseFloat(tX) > this.props.delta) {
              this.detectedSwipe = true;
            } else if (parseFloat(tX) < -this.props.delta) {
              this.detectedSwipe = true;
            }
          }
        }

        // console.log('Math.abs(tX)', Math.abs(tX));
        // console.log('Math.abs(tY)', Math.abs(tY));

        if (Math.abs(tX) > Math.abs(tY)) {
          fading.css({
            transform: `translateX(${tX}px)`
          });
        }

      }
    }

  };

  moveEnd = (e) => {

    const stonesPage = (_.last(this.props.routes).path === "/stones"),
      reviewPage = (_.last(this.props.routes).path === "/summary");

    if ($(window).width() < 768 && (stonesPage || reviewPage)) {

      // e.preventDefault();

      $('.main-wrapper').removeClass('grabbable');

      const fading = stonesPage ? $('.header-logo, .stone-filter').add($('.step2Cont').filter(function () {
        return !$(this).is(':offscreen')
      })) : $('.header-logo, .review-submit-screen-title, .review-submit-side-divider-left, .review-submit-right-logo, .review-submit-scroll-pane');

      let
        x = parseFloat(e.clientX ? e.clientX : (e.touches[0] ? e.touches[0].clientX : e.changedTouches[0].clientX)).toFixed(2),
        tX = parseFloat((x - this.x).toFixed(2));

      this.x = 0;
      this.y = 0;
      this.statusSwipe = false;

      if (!this.detectedSwipe) {

        this.detectedSwipe = false;

        if (Math.abs(parseFloat(tX)) >= this.state.delta) {
          if (parseFloat(tX) > this.state.delta) {
            fading.css({
              transform: ''
            });
            this.handlePrevClick(e);
          } else if (parseFloat(tX) < -this.state.delta) {
            fading.css({
              transform: ''
            });
            stonesPage && this.handleNextClick(e);
          }
          fading.removeClass('transition2');
          return false;
        } else {
          fading.css({
            transform: ''
          });
          fading.removeClass('transition2');
        }
      }
    }

  };

  handleBackToDashboard = () => {
    if(StonesStore.getUnsavedChanges()) {
      this.setState({
        isDialogVisible: true,
        handleDialogNoClick: () => this.setState({isDialogVisible: false}),
        handleDialogYesClick: () => (Config.parent && Config.parent.exitEditQuote && Config.parent.exitEditQuote()),
        messageBoxText: "Unsaved changes are detected, are you sure you wish to leave without saving changes?",
        messageBoxIsError: false
      });
    } else {
      Config.parent && Config.parent.exitEditQuote && Config.parent.exitEditQuote()
    }
  };

  render() {
    const
      f = StonesStore.fabricator(),
      stonesPage = (_.last(this.props.routes).path === "/stones"),
      reviewPage = (_.last(this.props.routes).path === "/summary"),
      pjscope = (!stonesPage && !reviewPage),
      mainMenu = StonesStore.getMainMenu();

    let headerClasses = "header-bar ";

    headerClasses = pjscope ? headerClasses + "header-bar-scope" : headerClasses;
    headerClasses = stonesPage ? headerClasses + "header-bar-stones" : headerClasses;
    headerClasses = reviewPage ? headerClasses + "header-bar-summary" : headerClasses;

    const headerStyle = {};
    if (f) {
      headerStyle.backgroundImage = `url(${f.ImageUrl})`;
    }

    return (
      <div className={"app-container"
      + (pjscope ? " app-container--pj-scope" : "")
      + (stonesPage ? " app-container--stones" : "")
      + (reviewPage ? " app-container--review" : "")
      + (this.state.switchToKV ? " app-container--kv" : "")
      + (Config.isInterentExplorer() ? " ie" : "")
      + (Config.isEdge() ? " edge" : "")
      + (Config.isFirefox() ? " firefox" : "")
      }>
        <div className="app-container-content" onTouchStart={this.moveStart} onTouchMove={this.move}
             onTouchEnd={this.moveEnd}
             onMouseDown={this.moveStart} onMouseMove={this.move} onMouseUp={this.moveEnd}>
          <div className={"main-wrapper" + (Config.isTabletMode() ? " tablet-mode" : "")}>
            <TimerView/>
            <LoaderView title="Saving Quote" text="Please wait while we save your quote."
                        visible={this.state['debug-loader']}/>
            {(mainMenu && mainMenu.length) ? (<HomeButton mainMenu={mainMenu}/>) : null}
            <div className={headerClasses}>
              <div className="header-logo" style={headerStyle}/>
              {this.renderHeader()}
            </div>

            {React.Children.map(this.props.children,
              (child) => React.cloneElement(child, {
                openKitchenVisualizerIframe: this.toggleSwitchToKV,
                switchToKV: this.state.switchToKV,
                goToNextView: this.handleNextClick,
                isDocked: this.isDocked,
                goToStonesView: this.handleGoToClick.bind(this, '/stones')
              })
            )}

            {this.state.isMessageBoxVisible ?
              <MessageBox message={this.state.messageBoxText} click={this.handleMessageBoxOkClick}
                          error={this.state.messageBoxIsError}/> : null}

            {this.state.isDialogVisible ?
              <MessageBox message={this.state.messageBoxText} buttonClass="message-system-dismiss-button-wrapper-dialog" buttons={[{
                  text: "No, Don't Exit Yet",
                  click: this.state.handleDialogNoClick
                }, {
                  text: "Yes, Exit Anyway",
                  click: this.state.handleDialogYesClick
                }]}
                error={this.state.messageBoxIsError}/>
            : null }
          </div>
          {this.renderFooter()}
        </div>
        <div className={"review-submit-iframe-pane review-submit-iframe-pane--fixed"}>
          {!this.state.reloadIframe && (
            <KitchenVisualizerIFrame quote={this.state.currentQuote} fullScreen={true} isSelected={true}
                                     switchedToKV={this.state.switchToKV}
                                     iframeOpened={this.state.iframeOpened}
                                     closeIframe={this.toggleSwitchToKV}/>)}
        </div>
        <MobileRotateButton/>
        <SquareFootCalculatorView/>
        <ConfirmDialog/>
      </div>
    );
  };

  renderBreadCrumb = () => {
    const path = _.last(this.props.routes).path || '/scope';

    let l = -1;

    switch (path) {
      case "/summary":
        l = 2;
        break;
      case '/stones':
        l = 1;
        break;
      case '/scope':
        l = 0;
        break;
    }

    return (
      <div className="breadcrumb-trail">
        <div className={"breadcrumb-crumb " + ((l >= 0) ? 'breadcrumb-crumb--green' : '')}
             onClick={this.handleGoToClick.bind(this, '/scope')}>
          <h3>1</h3>
          <h4>PROJECT SCOPE</h4>
        </div>
        <div className={"breadcrumb-crumb " + ((l >= 1) ? 'breadcrumb-crumb--green' : '')}
             onClick={this.handleGoToClick.bind(this, '/stones')}>
          <h3>2</h3>
          <h4>SELECT STONE</h4>
        </div>
        <div className={"breadcrumb-crumb " + ((l >= 2) ? 'breadcrumb-crumb--green' : '')}
             onClick={this.handleGoToClick.bind(this, '/summary')}>
          <h3>3</h3>
          <h4>REVIEW AND SUBMIT</h4>
          <div className="breadcrumb-arrow"/>
        </div>
      </div>
    );
  };

  renderHeader = () => {
    const f = StonesStore.fabricator();
    const linkPhone = document.kvConfig.kioskMode ? '#' : "tel:" + (f ? f.Phone : '');
    return (
      <div className="header-info-wrapper">
        <div className="header-info-cart">
          <div className="header-info-cart-amount">{this.state.quotesCount}</div>
        </div>
        <div className="header-info-phone-number"><a href={linkPhone}
                                                     onClick={this.handlePhoneNumberClick}>{f ? Misc.formatPhone(f.Phone) : ''}</a>
        </div>
        {//!Config.isInterentExplorer() ? (
          <div className="header-info-kv" onClick={this.toggleSwitchToKV}>view in visualizer</div>
          //) : (<a href="/kv" className="header-info-kv" target="_blank">view in visualizer</a>)
        }
      </div>
    );
  };

  renderFooter = () => {
    const path = _.last(this.props.routes).path || '/scope';
    let nextButtonText = 'Next';
    let projectScope = false;
    let showSaveButton = true;
    switch (path) {
      case "/scope":
        projectScope = true;
        nextButtonText = 'Select Stone';
        break;
      case '/stones':
        break;
      case '/summary':
        nextButtonText = ProjectScope.isBackend ? "Save" : "Next";
        showSaveButton = ProjectScope.isInKioskMode || ProjectScope.canSaveQuote;
        break;
    }
    const dashboardIframe = _.includes(window.location.href, "mode=dashboard");

    return (
      <div className={"footer-wrapper" + (projectScope ? " footer-wrapper--scope" : "")}>
        <div className="footer-wrapper__inner">
          <div className="footer-wrapper-breadcrumbs">
            {!dashboardIframe ? (
              this.renderBreadCrumb()
            ) : (
              <div className="breadcrumb-trail breadcrumb-trail--back-button">
                <button className="ui-button ui-button--green">
                  <span className="ui-button-text" onClick={this.handleBackToDashboard}>BACK TO DASHBOARD</span>
                </button>
              </div>
            )}
            <div className="footer-visualize" onClick={this.toggleSwitchToKV}>
              <span className="footer-visualize-image"/>
              <span className="footer-visualize-text">Visualize My Kitchen</span>
            </div>
          </div>
          <div
            className={"footer-button-container " + (!projectScope ? "footer-button-container--multiple" : "")}>
            {!projectScope
              ? (
                <div className="footer-back-button" onClick={this.handlePrevClick}>
                  <div className="footer-back-button-endcap"/>
                  Back
                </div>)
              : null}
            {showSaveButton && (<div className="footer-forward-button" onClick={this.handleNextClick}>
              <div className="footer-forward-button-endcap"/>
              {nextButtonText}
            </div>)
            }
          </div>
        </div>
      </div>
    );
  }
};



// WEBPACK FOOTER //
// ./src/components/mainView.js